export const getPageTitle = (): string => {
    return process.env.VUE_APP_PAGE_TITLE;
};
